import axios from 'axios';
const base = (process.env.VUE_APP_ROOT_API || '/').replace(/\/?$/, '/');
export const publicClaimsApi = axios.create({ baseURL: base + 'claims-public/', timeout: 60000 });
export function claimRequest(method, path = '', data, params) {
  return axios({ method, url: base + 'claims' + path, data, params, headers: { Authorization: 'Bearer ' + localStorage.getItem('token'), 'X-Current-Page': 'claims' } }).then(r => r.data);
}
export function downloadBlob(blob, filename) {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url; anchor.download = filename; document.body.appendChild(anchor); anchor.click(); anchor.remove();
  setTimeout(() => URL.revokeObjectURL(url), 30000);
}
export async function downloadClaimFile(path, name) {
  const response = await axios.get(base + 'claims' + path, { responseType: 'blob', headers: { Authorization: 'Bearer ' + localStorage.getItem('token'), 'X-Current-Page': 'claims' } });
  downloadBlob(response.data, name);
}
export function errorText(e) {
  const message = e?.response?.data?.message;
  return Array.isArray(message) ? message.join('\n') : message || e.message;
}
export function requestId() {
  if (crypto.randomUUID) return crypto.randomUUID();
  const b = crypto.getRandomValues(new Uint8Array(16)); b[6] = (b[6] & 15) | 64; b[8] = (b[8] & 63) | 128;
  const h = Array.from(b, n => n.toString(16).padStart(2, '0')).join('');
  return h.slice(0,8)+'-'+h.slice(8,12)+'-'+h.slice(12,16)+'-'+h.slice(16,20)+'-'+h.slice(20);
}
